import { SxProps } from '@mui/material';
import { CSSProperties } from 'react';
import { black1, grey10, white } from 'app/components/ThemeProvider/colors';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');
export const outlinedInput: SxProps = {
  height: '40px',
  background: 'transparent',
  border: 'none',

  '& fieldset': {
    border: 'none',
    background: 'transparent',
  },

  '& fieldset.MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },

  [theme.breakpoints.down('sm')]: {
    width: '146px',
  },
};

export const btnSearch = (bg: boolean, searchInput: boolean) => {
  return {
    width: 'fit-content',
    border: 'none',
    height: '40px',
    minWidth: '48px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    p: !searchInput ? '0px !important' : '0px 16px 0px 12px !important',
    gap: !searchInput ? '0px' : '8px',
    '& .MuiSvgIcon-root': {
      width: '24px',
      height: '24px',
    },
  };
};
export const inputStyle: CSSProperties = {
  background: 'transparent',
  paddingLeft: '12px',
  fontSize: '16px',
  fontFamily: 'Yelo',
  color: black1,
  caretColor: 'rgba(20, 25, 31, 0.40)',
};

export const inputAdornment: SxProps = {
  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
    position: 'relative',
    left: '16px',
  },

  '&:hover': {
    cursor: ' pointer',
  },
};

export const startAdornment: SxProps = {
  '& .MuiSvgIcon-root': {
    width: '24px',
    height: '24px',
    position: 'relative',
  },
};
